import script from "./AudienceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__